import React from 'react'
import ListItem from '../ListItem'
import * as Styled from './styled'
import { useSettingsItemsData } from './consts'
import { useAspectRatioWarning } from 'hooks/useAspectRatioWarning'
import AspectRatioWarningPopup from 'common-components/AspectRatioWarningPopup'

const SettingsBlock = () => {
  const settingsItemsData = useSettingsItemsData()
  const {
    handleAspectRatioClick,
    showWarning,
    pendingSelection,
    handleConfirmSwitch,
    handleCancelSwitch
  } = useAspectRatioWarning()

  const settingsItemsWithClick = settingsItemsData.map(item => {
    if (item.id === 'aspect-ratio') {
      return { ...item, onClick: handleAspectRatioClick }
    }
    return item
  })

  return (
    <>
      <Styled.SettingsBlock>
        <Styled.Lists>
          {settingsItemsWithClick.map(listItemData => (
            <ListItem key={listItemData.id} data={listItemData} />
          ))}
        </Styled.Lists>
      </Styled.SettingsBlock>

      <AspectRatioWarningPopup
        isOpen={showWarning}
        pendingSelection={pendingSelection}
        onConfirm={handleConfirmSwitch}
        onCancel={handleCancelSwitch}
      />
    </>
  )
}

export default SettingsBlock
